<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
  </div>
  <drdp-container [additionClasses]="'min-h-[44rem]'">
    <div class="w-full">
      <drdp-container color="lightBlue">
        <form class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-8 gap-y-4" [formGroup]="ratingCompletionSearch"
          (ngSubmit)="handleSearch()">
          @if (hasAccessToPilot) {
            <div class="lg:col-span-5 md:col-span-2 col-span-1">
              <mat-checkbox color="primary" (change)="handleGlobal()" formControlName="isAllFieldStudy">
              </mat-checkbox>
              <label class="inline">
                {{ t('ratingCompletion.allFieldStudy') }}
              </label>
            </div>
          }
          <div class="col-span-1 my-auto">
            <drdp-select-state #stateSelect [initialStateId]="stateId.value" (state)="handleDropdown($event, selectType.States)"
              [clear]="clearDropdowns" [required]="true">
            </drdp-select-state>
          </div>

          @if (!isAllFieldStudy.value) {
            <div class="col-span-1 my-auto">
              <drdp-select-agency #agencySelect [initialAgencyId]="agencyId.value" (agency)="handleDropdown($event, selectType.Agencies)"
                [multiSelect]="multiSelectAgencies" [stateId]="stateId.value" [clear]="clearDropdowns" [required]="true">
              </drdp-select-agency>
            </div>
          }

          @if (!isAllFieldStudy.value && !multiSelectAgencies) {
            <div class="col-span-1 my-auto">
              <drdp-select-site (site)="handleDropdown($event, selectType.Sites)" [agencyId]="agencyId.value"
                [multiSelect]="true" [multiSelectInitVals]="true" [clear]="clearDropdowns" [required]="true">
              </drdp-select-site>
            </div>
          }

          <div class="col-span-1 self-end">
            <drdp-select-global-rating (ratingPeriod)="handleDropdown($event, selectType.RatingPeriods)" [required]="true"
              [initialRatingPeriodId]="globalRatingPeriodId.value" [showPilotRps]="isAllFieldStudy.value" [clear]="clearDropdowns" [showAll]="true">
            </drdp-select-global-rating>
          </div>
          @if (!isAllFieldStudy.value && !multiSelectAgencies) {
            <div class="col-span-1 self-end">
              <drdp-select-class (classroom)="handleDropdown($event, selectType.Class)" [siteIds]="siteIds.value"
                [globalRatingPeriodId]="globalRatingPeriodId.value" [clear]="clearDropdowns" [required]="true" [useClassroomId]="true">
              </drdp-select-class>
            </div>
          }
          <div class="lg:col-span-2 flex flex-row md:flex-col-1 gap-5 lg:flex-row lg:justify-start lg:items-end">
            <div class="mb-0 md:mb-2 lg:mb-0">
              <drdp-btn type="submit" [disabled]="ratingCompletionSearch.invalid" class="lg:mr-2">{{ 'common.search' | transloco }}</drdp-btn>
            </div>
            <div>
              <drdp-btn color="outline" type="button" (click)="onClear()">{{ 'shared.actions.clear' | transloco }}</drdp-btn>
            </div>
          </div>
        </form>
      </drdp-container>
      <drdp-add-edit-table
        [dataSource]="dataSource"
        [tableData]="tableData"
        [columns]="tableColumns"
        viewIcon="uil uil-file text-drdpblue-300"
        (iconActionItem)="onIconClick($event)"
        >
      </drdp-add-edit-table>
      <div>
        <mat-paginator
          [pageSizeOptions]="pageSizeOptions"
          [pageSize]="pageSize"
          [length]="totalData"
          [pageIndex]="pageIndex"
          (page)="paginateTable(false)">
        </mat-paginator>
      </div>
    </div>
  </drdp-container>
</div>
</ng-container>
